var _path, _rect, _circle, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopUpSuccessfully(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 106,
    viewBox: "0 0 237 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4397 102.966H182.874C188.344 102.966 192.778 98.4907 192.778 92.9697C192.778 87.4487 188.344 82.9731 182.874 82.9731C182.874 82.9731 174.385 78.4974 174.385 72.9765C174.385 67.4555 179.976 62.9798 186.873 62.9798H201.268C206.738 62.9798 211.172 58.5042 211.172 52.9832C211.172 47.4622 206.738 42.9865 201.268 42.9865H170.14C175.61 42.9865 180.045 38.5109 180.045 32.9899C180.045 27.4689 175.61 22.9933 170.14 22.9933H226.735C232.205 22.9933 236.64 18.5176 236.64 12.9966C236.64 7.47565 232.205 3 226.735 3H88.0777C82.6078 3 78.1736 7.47565 78.1736 12.9966C78.1736 18.5176 82.6078 22.9933 88.0777 22.9933H31.4827C26.0128 22.9933 21.5786 27.4689 21.5786 32.9899C21.5786 38.5109 26.0128 42.9865 31.4827 42.9865H66.8546C72.3245 42.9865 76.7587 47.4622 76.7587 52.9832C76.7587 58.5042 72.3245 62.9798 66.8546 62.9798H10.2596C4.7897 62.9798 0.355469 67.4555 0.355469 72.9765C0.355469 78.4974 4.7897 82.9731 10.2596 82.9731H65.4397C59.9698 82.9731 55.5356 87.4487 55.5356 92.9697C55.5356 98.4907 59.9698 102.966 65.4397 102.966ZM216.651 52.986C216.651 58.507 221.127 62.9827 226.648 62.9827C232.169 62.9827 236.645 58.507 236.645 52.986C236.645 47.465 232.169 42.9894 226.648 42.9894C221.127 42.9894 216.651 47.465 216.651 52.986Z",
    fill: "#EAEDE2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.3545,
    y: 12,
    width: 120,
    height: 72,
    fill: "#E3EDC3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 74,
    r: 25,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.198 48.9987V49.954L173.063 50.3579C182.103 54.5762 188.408 63.6013 188.408 74.2689C188.408 88.5442 176.837 100.263 162.413 100.263C152.494 100.263 143.779 94.7037 139.424 86.4424L139.002 85.6419H138.097H56.5665C51.8321 85.6419 48.0537 81.8637 48.0537 77.1291V19.2789C48.0537 14.5445 51.8319 10.7661 56.5665 10.7661H163.685C168.419 10.7661 172.198 14.5443 172.198 19.2789V48.9987ZM170.43 19.2792V19.2789C170.43 15.5891 167.373 12.5343 163.685 12.5343H56.5668H56.5657C52.8759 12.5343 49.821 15.5905 49.821 19.2789V25.159V26.659H51.321H168.929H170.428L170.429 25.1593L170.43 19.2792ZM51.3222 36.3736H49.8222V37.8736V77.1291C49.8222 80.8187 52.8771 83.8738 56.5668 83.8738L136.032 83.8741L138.037 83.8741L137.471 81.9507C136.707 79.3561 136.26 76.7976 136.26 74.1095C136.26 59.8343 147.831 48.1151 162.255 48.1151C164.504 48.1151 166.614 48.4151 168.592 48.8716L170.43 49.2954V47.4099V37.8736V36.3736H168.93H51.3222ZM142.253 87.974L142.258 87.9815L142.264 87.9889C146.668 94.4265 153.96 98.4952 162.255 98.4952C175.632 98.4952 186.646 87.4983 186.481 74.1007C186.478 65.1156 181.557 57.3298 174.292 53.106L174.28 53.0987L174.267 53.0916C172.807 52.28 171.094 51.4165 169.173 50.8915C166.823 50.2212 164.462 49.8829 162.095 49.8829C148.712 49.8829 137.869 60.7259 137.869 74.1092C137.869 77.1827 138.55 80.2198 139.551 82.8934C140.249 84.8069 141.279 86.5116 142.253 87.974Z",
    stroke: "#274642",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5811,
    y: 27,
    width: 125,
    height: 8,
    fill: "#274642"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.818 67L158.818 82L152 75.1818",
    stroke: "#A9CF3D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUpSuccessfully);
export default __webpack_public_path__ + "static/media/top-up-successfully.3b9a36df4785ed8574db75c212d45493.svg";
export { ForwardRef as ReactComponent };